// ResetPassword.jsx
import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import LayoutMUI from "./Layout";
import { FormattedMessage, useIntl } from "react-intl";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { AppContext } from "../utilities/context";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

const ResetPassword = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const { token } = useParams(); // Token desde la URL
  const navigate = useNavigate();

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState(
        [
          { label: intl.formatMessage({ id: "app.header.home.label" }), url: "/" },
          { label: intl.formatMessage({ id: "app.header.login.label" }), url: "/login" },
        ]
      );
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/reset-password", {
        token,
        newPassword,
      });
      setMessage(response.data.message);
      if (response.data.success) {
        navigate("/login"); // Redirigir al login
      }
    } catch (error) {
      setMessage(error.response?.data?.message || "Error desconocido");
    }
  };

  return (
    <LayoutMUI>
      <div>
        <form onSubmit={handleSubmit}>
          <Grid
            container
            direction={"column"}
            spacing={2}
            className={"forgotPasswordContainer"}
          >
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              <FormattedMessage id="app.terms.title.pp" defaultMessage={"Restablecer Contraseña"} />
            </Typography>
          </Grid>
            <Grid item>
              <FormControl fullWidth>
                <TextField
                  id="password"
                  name="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  //   required
                  fullWidth
                  label={"Password"}
                  placeholder={"Password"}
                  type={"password"}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button type={"submit"} variant={"contained"} color={"primary"}>
                <FormattedMessage
                  id="app.recovery.submit"
                  defaultMessage="Cambiar Contraseña"
                />
              </Button>
            </Grid>
          </Grid>
        </form>
        {message && <p>{message}</p>}
      </div>
    </LayoutMUI>
  );
};

export default ResetPassword;
